import { ERROR, LOADING } from "./actions.type";

const state = {
  errors: null,
  loading: false
};

const mutations = {
  [ERROR.SET](state, error) {
    state.errors = error;
  },
  [LOADING.SET](state) {
    state.loading = !state.loading;
  }
};

const getters = {
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  }
};

const actions = {
  [ERROR.PUSH](context, e) {
    context.commit(ERROR.SET, e);
  },
  [LOADING.TOGGLE](context) {
    context.commit(LOADING.SET);
  },
  [ERROR.DEL](context) {
    context.commit(ERROR.SET, null);
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
